/* eslint-disable no-invalid-this */
import { postDataUsingTeamidAndDataid, getDataWithTeamid, postDataUsingTeamid } from '../../api/cloudApiGenerated';

const DataCollection = () => {
  let exports = {},
    dataDetails,
    page = 1,
    pageSize = 12;

  function updateData(newData) {
    dataDetails = newData;
  }

  function addDataCollection(target, highed, teamId, saveDataCollectionDetails, editor) {
    function validateFields(fields) {
      let found = true;
      fields.forEach((field) => {
        if (field.type === 'text' || field.type === 'textarea') {
          if (field.value === '') {
            found = false;
          }
        }
      });
      return found;
    }

    getDataWithTeamid(teamId, page, pageSize).then((data) => {
      let dataPicker;
      if (!dataPicker) {
        dataPicker = highed.dom.cr('div', 'col-xs-12 no-data-div', 'You have no data.');
      }

      if (data.data.length > 0) {
        let table = highed.dom.cr('table', 'table table-striped'),
          tHeader = highed.dom.cr('thead', ''),
          tHeaderRow = highed.dom.cr('tr', ''),
          tBody = highed.dom.cr('tbody', ''),
          length = 200;

        highed.dom.ap(
          tHeader,
          highed.dom.ap(
            tHeaderRow,
            highed.dom.cr('th', '', 'Name'),
            highed.dom.cr('th', '', 'Details'),
            highed.dom.cr('th', '', 'Type'),
            highed.dom.cr('th', '', 'Live'),
            highed.dom.cr('th', '', 'Referenced'),
            highed.dom.cr('th', '', ''),
            highed.dom.cr('th', '', '')
          )
        );

        let editBtns = [],
          selectBtns = [];

        data.data.forEach((record) => {
          const row = highed.dom.cr('tr', '');

          let recordNameSpan = highed.dom.cr('span', '', record.name),
            recordProviderSpan = highed.dom.cr('span', '', record.type),
            recordNameInput = highed.dom.cr('input', 'form-control'),
            editBtn = highed.dom.cr('button', 'btn btn-success', 'Edit'),
            checkbox = highed.dom.cr('input', ''),
            referenceCheckbox = highed.dom.cr('input', ''),
            details,
            googleKey,
            googleWorksheet,
            googleRefresh,
            liveURL,
            type,
            interval,
            propertiesSpan,
            propertiesInputs;

          referenceCheckbox.type = checkbox.type = 'checkbox';

          if (record.referenced) {
            referenceCheckbox.checked = record.referenced;
          }

          let selectBtn = highed.dom.cr('button', 'btn btn-primary', 'Select');
          highed.dom.on(selectBtn, 'click', () => {
            if (selectBtn.innerHTML === 'Select') {
              const project = dataDetails ? JSON.parse(dataDetails) : editor.chart.toProject();

              if (project.options) delete project.options.data;
              if (project.settings) delete project.settings.dataProvider;

              if (record.details) {
                const dataset = JSON.parse(record.details);
                project.settings.dataProvider = dataset;
              }

              saveDataCollectionDetails(project, record);
            } else {
              editBtns.forEach((e) => {
                e.disabled = false;
              });

              selectBtns.forEach((s) => {
                s.disabled = false;
              });

              selectBtn.className = 'btn btn-primary';
              selectBtn.innerHTML = 'Select';
              editBtn.innerHTML = 'Edit';
              if (details.csv) checkbox.disabled = true;
              referenceCheckbox.disabled = true;
              recordNameSpan.style.display = 'block';
              propertiesSpan.style.display = 'block';
              recordNameInput.style.display = 'none';
              propertiesInputs.style.display = 'none';
            }
          });

          if (record.details) {
            // Parse Details
            details = JSON.parse(record.details);
            if (details.csv) {
              const trimmedString =
                details.csv.length > length ? details.csv.substring(0, length - 3) + '...' : details.csv;
              propertiesSpan = highed.dom.cr('span', '', trimmedString);
              propertiesInputs = highed.dom.cr('textarea', 'form-control');
              propertiesInputs.innerHTML = details.csv;
              if (record.live) checkbox.checked = true;
            } else if (details.googleSpreadsheet) {
              propertiesSpan = highed.dom.ap(
                highed.dom.cr('span', '', '<b>Key:</b> ' + details.googleSpreadsheet.googleSpreadsheetKey),
                highed.dom.cr('br', ''),
                highed.dom.cr(
                  'span',
                  '',
                  '<b>Worksheet:</b> ' + (details.googleSpreadsheet.googleSpreadsheetWorksheet || '1')
                ),
                highed.dom.cr('br', ''),
                highed.dom.cr(
                  'span',
                  '',
                  '<b>Refresh Rate:</b> ' + (details.googleSpreadsheet.dataRefreshRate || '0') + ' seconds'
                )
              );

              googleKey = highed.dom.cr('input', 'form-control');
              googleKey.value = details.googleSpreadsheet.googleSpreadsheetKey;
              googleWorksheet = highed.dom.cr('input', 'form-control');
              googleWorksheet.value = details.googleSpreadsheet.googleSpreadsheetWorksheet || 1;
              googleRefresh = highed.dom.cr('input', 'form-control');
              googleRefresh.value = details.googleSpreadsheet.dataRefreshRate || 0;

              propertiesInputs = highed.dom.ap(
                highed.dom.cr('span', 'data-collection-inputs'),
                highed.dom.ap(
                  highed.dom.cr('span'),
                  highed.dom.cr('label', 'col-sm-2', 'Key: '),
                  highed.dom.ap(highed.dom.cr('div', 'col-sm-10'), googleKey)
                ),
                highed.dom.ap(
                  highed.dom.cr('span'),
                  highed.dom.cr('label', 'col-sm-2', 'Sheet: '),
                  highed.dom.ap(highed.dom.cr('div', 'col-sm-10'), googleWorksheet)
                ),
                highed.dom.ap(
                  highed.dom.cr('span'),
                  highed.dom.cr('label', 'col-sm-2', 'Refresh Rate: '),
                  highed.dom.ap(highed.dom.cr('div', 'col-sm-10'), googleRefresh)
                )
              );
              checkbox.checked = true;
            } else if (details.liveData) {
              propertiesSpan = highed.dom.ap(
                highed.dom.cr(
                  'span',
                  '',
                  '<b>URL:</b> ' +
                    (details.liveData.csvURL
                      ? details.liveData.csvURL
                      : details.liveData.rowsURL
                      ? details.liveData.rowsURL
                      : details.liveData.columnsURL)
                ),
                highed.dom.cr('br', ''),
                highed.dom.cr(
                  'span',
                  '',
                  '<b>Type:</b> ' +
                    (details.liveData.csvURL
                      ? 'CSV'
                      : details.liveData.rowsURL
                      ? 'JSON (Rows Ordered)'
                      : 'JSON (Columns Ordered)')
                ),
                highed.dom.cr('br', ''),
                highed.dom.cr(
                  'span',
                  '',
                  '<b>Refresh Rate:</b> ' + (details.liveData.dataRefreshRate || '0') + ' Seconds'
                )
              );

              liveURL = highed.dom.cr('input', 'form-control');
              liveURL.value = details.liveData.csvURL
                ? details.liveData.csvURL
                : details.liveData.rowsURL
                ? details.liveData.rowsURL
                : details.liveDatacolumnsURL;

              type = highed.dom.ap(
                highed.dom.cr('select', 'form-control'),
                highed.dom.cr('option', '', 'JSON (Columns Ordered)', 'columnsURL'),
                highed.dom.cr('option', '', 'JSON (Rows Ordered)', 'rowsURL'),
                highed.dom.cr('option', '', 'CSV', 'csvURL')
              );

              type.selectedIndex = details.liveData.csvURL ? 2 : details.liveData.rowsURL ? 1 : 0;
              interval = highed.dom.cr('input', 'form-control');
              interval.value = details.liveData.dataRefreshRate;
              propertiesInputs = highed.dom.ap(
                highed.dom.cr('span', 'data-collection-inputs'),
                highed.dom.ap(
                  highed.dom.cr('span'),
                  highed.dom.cr('label', 'col-sm-2', 'URL: '),
                  highed.dom.ap(highed.dom.cr('div', 'col-sm-10'), liveURL)
                ),
                highed.dom.ap(
                  highed.dom.cr('span'),
                  highed.dom.cr('label', 'col-sm-2', 'Type: '),
                  highed.dom.ap(highed.dom.cr('div', 'col-sm-10'), type)
                ),
                highed.dom.ap(
                  highed.dom.cr('span'),
                  highed.dom.cr('label', 'col-sm-2', 'Refresh Rate: '),
                  highed.dom.ap(highed.dom.cr('div', 'col-sm-10'), interval)
                )
              );
              checkbox.checked = true;
            } else {
              propertiesSpan = highed.dom.cr('span', '', details.dataProvider);
              propertiesInputs = highed.dom.cr('textarea', 'form-control');
              propertiesInputs.innerHTML = details.dataProvider;
            }
          }

          checkbox.disabled = referenceCheckbox.disabled = true;

          recordNameInput.value = record.name;
          recordNameInput.style.display = 'none';

          propertiesInputs.style.display = 'none';

          highed.dom.on(editBtn, 'click', () => {
            if (editBtn.innerHTML === 'Edit') {
              // Need to disable all other buttons
              editBtn.innerHTML = 'Save';
              selectBtn.innerHTML = 'Cancel';
              selectBtn.className = 'btn btn-danger';
              editBtns.forEach((e) => {
                if (e.innerHTML === 'Edit') e.disabled = true;
              });

              selectBtns.forEach((s) => {
                if (s.innerHTML === 'Select') s.disabled = true;
              });

              if (details.csv) {
                checkbox.disabled = false;
              }

              referenceCheckbox.disabled = false;

              recordNameSpan.style.display = 'none';
              propertiesSpan.style.display = 'none';
              recordNameInput.style.display = 'block';
              propertiesInputs.style.display = 'block';
            } else {
              // The button is in Save Mode so lets save and revert the "Save" button back to "Edit"
              if (details.csv) {
                details.csv = propertiesInputs.value;
              } else if (details.googleSpreadsheet) {
                details.googleSpreadsheet.googleSpreadsheetKey = googleKey.value;
                details.googleSpreadsheet.googleSpreadsheetWorksheet = googleWorksheet.value;
                details.googleSpreadsheet.dataRefreshRate = googleRefresh.value;
                details.googleSpreadsheet.enablePolling = parseInt(googleRefresh.value, 10) !== 0;
              } else if (details.liveData) {
                details.liveData = {};
                details.liveData[
                  type.selectedIndex === 0 ? 'columnsURL' : type.selectedIndex === 1 ? 'rowsURL' : 'csvURL'
                ] = liveURL.value;
                details.liveData.dataRefreshRate = interval.value;
                details.liveData.enablePolling = parseInt(interval.value, 10) !== 0;
              }

              let liveCheck = 0;
              let referenceCheck = 0;

              if (checkbox.checked) liveCheck = 1;
              if (referenceCheck.checked) referenceCheck = 1;

              const body = {
                data: JSON.stringify(details),
                live: liveCheck,
                referenced: referenceCheck,
                name: recordNameInput.value,
              };

              postDataUsingTeamidAndDataid(teamId, record.data_setting_id, body)
                .then((data) => {
                  if (!data.error) {
                    target.innerHTML = '';
                    //createDataCollectionList(target);

                    addDataCollection(target, highed, teamId, saveDataCollectionDetails, editor);
                  }
                })
                .catch(() => {});
            }
          });

          editBtns.push(editBtn);
          selectBtns.push(selectBtn);

          highed.dom.ap(
            tBody,
            highed.dom.ap(
              row,
              highed.dom.ap(highed.dom.cr('td', ''), recordNameSpan, recordNameInput),
              highed.dom.ap(highed.dom.cr('td', ''), propertiesSpan, propertiesInputs),
              highed.dom.ap(highed.dom.cr('td', ''), recordProviderSpan),
              highed.dom.ap(highed.dom.cr('td', ''), checkbox),
              highed.dom.ap(highed.dom.cr('td', ''), referenceCheckbox),
              highed.dom.ap(highed.dom.cr('td', 'btn-table-cell'), editBtn),
              highed.dom.ap(highed.dom.cr('td', 'btn-table-cell'), selectBtn)
            )
          );
        });

        dataPicker = highed.dom.ap(highed.dom.cr('div', 'tab-table-container'), highed.dom.ap(table, tHeader, tBody));
      }

      const nextBtn = highed.dom.cr('button', 'btn btn-page btn-page-end', 'Next');
      const previousBtn = highed.dom.cr('button', 'btn btn-page btn-page-start', 'Previous');
      highed.dom.on(previousBtn, 'click', () => {
        page -= 1;
        target.innerHTML = '';
        addDataCollection(target, highed, teamId, saveDataCollectionDetails, editor);
      });
      highed.dom.on(nextBtn, 'click', () => {
        page += 1;
        target.innerHTML = '';
        addDataCollection(target, highed, teamId, saveDataCollectionDetails, editor);
      });

      const newDataBtn = highed.dom.cr(
        'button',
        'btn btn-page',
        '<span class="glyphicon glyphicon-plus-sign"/></span> New'
      );

      highed.dom.on(newDataBtn, 'click', () => {
        target.innerHTML = '';

        const newRecordName = highed.dom.cr('input', 'form-control');
        const newRecordType = highed.dom.ap(
          highed.dom.cr('select', 'form-control'),
          highed.dom.cr('option', '', 'CSV', 'csv'),
          highed.dom.cr('option', '', 'Google Spreadsheet', 'googlespreadsheet'),
          highed.dom.cr('option', '', 'Live Data', 'live')
        );
        const newSaveRecord = highed.dom.cr('button', 'btn btn-primary', 'Save');
        const newCancelRecord = highed.dom.cr('button', 'btn btn-primary', 'Cancel');
        const newRecordDiv = highed.dom.cr('div', 'new-data-record');

        let newRecordPropertiesDiv = highed.dom.cr('div', '');
        const newRecordPropertiesCSV = highed.dom.cr('textarea', 'form-control full-width-csv'),
          newRecordPropertiesCSVLive = highed.dom.cr('input', ''),
          newRecordPropertiesGoogleKey = highed.dom.cr('input', 'form-control'),
          newRecordPropertiesGoogleSheet = highed.dom.cr('input', 'form-control'),
          newRecordPropertiesGoogleRefreshRate = highed.dom.cr('input', 'form-control'),
          newRecordPropertiesLiveUrl = highed.dom.cr('input', 'form-control'),
          newRecordPropertiesLiveInterval = highed.dom.cr('input', 'form-control'),
          newRecordPropertiesLiveType = highed.dom.ap(
            highed.dom.cr('select', 'form-control'),
            highed.dom.cr('option', '', 'JSON (Column Ordered)', 'columnsURL'),
            highed.dom.cr('option', '', 'JSON (Row Ordered)', 'rowsURL'),
            highed.dom.cr('option', '', 'CSV', 'csvURL')
          );
        let selectValue = 0;
        let selectLiveDataTypeValue = 0;
        newRecordPropertiesCSVLive.type = 'checkbox';

        highed.dom.on(newRecordPropertiesLiveType, 'change', (e) => {
          selectLiveDataTypeValue = e.target.selectedIndex;
        });

        let newRecordProperties = highed.dom.ap(
          highed.dom.cr('span', '', ''),
          highed.dom.cr('label', '', '<b>Raw CSV:</b>'),
          newRecordPropertiesCSV,
          highed.dom.cr('label', '', '<b>Live: </b>'),
          newRecordPropertiesCSVLive
        );

        highed.dom.on(newRecordType, 'change', (e) => {
          newRecordPropertiesDiv.innerHTML = '';
          newRecordProperties.innerHTML = '';
          selectValue = e.target.selectedIndex;
          if (e.target.selectedIndex === 0) {
            // CSV
            newRecordProperties = highed.dom.ap(
              highed.dom.cr('label', 'full-width', '<b>Raw CSV</b>'),
              newRecordPropertiesCSV
            );
            highed.dom.ap(newRecordPropertiesDiv, newRecordProperties);
          } else if (e.target.selectedIndex === 1) {
            // Google Spreadsheet
            newRecordProperties = highed.dom.ap(
              highed.dom.cr('label', 'full-width', '<b>Google Spreadsheet Key: </b>'),
              newRecordPropertiesGoogleKey,
              highed.dom.cr('label', '', '<b>Worksheet: </b>'),
              newRecordPropertiesGoogleSheet,
              highed.dom.cr('label', '', '<b>Refresh Rate: </b>'),
              newRecordPropertiesGoogleRefreshRate
            );
          } else if (e.target.selectedIndex === 2) {
            // Live data
            newRecordProperties = highed.dom.ap(
              highed.dom.cr('label', 'full-width', '<b>Url: </b>'),
              newRecordPropertiesLiveUrl,
              highed.dom.cr('label', '', '<b>Type: </b>'),
              newRecordPropertiesLiveType,
              highed.dom.cr('label', '', '<b>Refresh Rate: </b>'),
              newRecordPropertiesLiveInterval
            );
          }
          highed.dom.ap(newRecordPropertiesDiv, newRecordProperties);
        });
        highed.dom.on(newCancelRecord, 'click', () => {
          target.innerHTML = '';
          //createDataCollectionList(target);

          addDataCollection(target, highed, teamId, saveDataCollectionDetails, editor);
        });
        highed.dom.on(newSaveRecord, 'click', () => {
          let details = {};
          if (!validateFields([newRecordName])) {
            highed.snackBar('Please enter a name');
            return;
          }
          if (selectValue === 0) {
            if (validateFields([newRecordPropertiesCSV])) {
              details.csv = newRecordPropertiesCSV.value;
              details.googleSpreadsheet = false;
              details.liveData = false;
            }
          } else if (selectValue === 1) {
            if (validateFields([newRecordPropertiesGoogleKey])) {
              details.csv = false;
              details.googleSpreadsheet = {};
              details.liveData = false;
              details.googleSpreadsheet.googleSpreadsheetKey = newRecordPropertiesGoogleKey.value;
              details.googleSpreadsheet.googleSpreadsheetWorksheet = newRecordPropertiesGoogleSheet.value;
              details.googleSpreadsheet.dataRefreshRate = newRecordPropertiesGoogleRefreshRate.value;
              details.googleSpreadsheet.enablePolling = parseInt(newRecordPropertiesGoogleRefreshRate.value, 10) !== 0;
            }
          } else if (selectValue === 2) {
            if (
              validateFields([newRecordPropertiesLiveUrl, newRecordPropertiesLiveInterval, newRecordPropertiesLiveType])
            ) {
              details.csv = false;
              details.googleSpreadsheet = false;
              details.liveData = {};
              details.liveData[
                selectLiveDataTypeValue === 0 ? 'columnsURL' : selectLiveDataTypeValue === 1 ? 'rowsURL' : 'csvURL'
              ] = newRecordPropertiesLiveUrl.value;
              details.liveData.dataRefreshRate = newRecordPropertiesLiveInterval.value;
              details.liveData.enablePolling = parseInt(newRecordPropertiesLiveInterval.value, 10) !== 0;
            }
          }
          // We should now have assembled our data object, now we can check to see if this is empty.
          const newRecordDetails = JSON.stringify(details);
          if (newRecordDetails !== '{}') {
            const newRecordBody = {
              data: newRecordDetails,
              name: newRecordName.value,
              provider: selectValue + 1,
              live: selectValue === 0 ? newRecordPropertiesCSVLive.checked : 1,
            };
            postDataUsingTeamid(teamId, newRecordBody)
              .then(() => {
                target.innerHTML = '';
                //createDataCollectionList(target);

                addDataCollection(target, highed, teamId, saveDataCollectionDetails, editor);
                highed.snackBar('Data added');
              })
              .catch(() => {});
          } else {
            highed.snackBar('Please make sure all mandatory fields are complete');
          }
        });

        highed.dom.ap(newRecordPropertiesDiv, newRecordProperties);

        highed.dom.ap(
          newRecordDiv,
          highed.dom.cr('label', '', '<b>Name:</b>'),
          newRecordName,
          highed.dom.cr('label', '', '<b>Type:</b>'),
          newRecordType,
          newRecordPropertiesDiv,
          highed.dom.cr('br'),
          newSaveRecord,
          newCancelRecord
        );

        highed.dom.ap(target, newRecordDiv);
      });

      const newButtonContainer = highed.dom.cr('div', 'new-button-container');
      highed.dom.ap(newButtonContainer, newDataBtn);

      const buttonsContainer = highed.dom.cr('div', '');
      const buttonContainer = highed.dom.cr('div', 'buttons-container');
      if (data.page !== 1) {
        // Theres only one page of results, hide the previous button
        highed.dom.ap(buttonContainer, previousBtn);
      }
      if (data.data.length !== 0 && data.pageCount !== data.page) {
        // Reached the end of the results, hide the next button
        highed.dom.ap(buttonContainer, nextBtn);
      }
      highed.dom.ap(buttonsContainer, newButtonContainer, buttonContainer);

      target = target || dataPicker.parentNode;

      highed.dom.ap(target, dataPicker, buttonsContainer);
    });
  }

  exports = {
    addDataCollection: addDataCollection,
    updateData: updateData,
  };

  return exports;
};

export default DataCollection;
